<template>
    <transition name="notification">
        <div v-if="show" class="notification" :class="type">
            <p>{{ message }}</p>
            <button @click="close" class="close-button">
                <span class="sr-only">Cerrar</span>
                <i class="fas fa-times"></i>
            </button>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'NotificationPage',
    props: {
        show: Boolean,
        message: String,
        type: {
            type: String,
            default: 'info',
            validator: (value) => ['info', 'success', 'warning', 'error'].includes(value),
        },
    },
    emits: ['close'],
    watch: {
        show(newValue) {
            if (newValue) {
                this.startAutoCloseTimer();
            }
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        startAutoCloseTimer() {
            setTimeout(() => {
                this.close();
            }, 5000);
        },
    },
    mounted() {
        if (this.show) {
            this.startAutoCloseTimer();
        }
    },
    beforeUnmount() {
        clearTimeout(this.autoCloseTimer);
    },
};
</script>

<style scoped>
.notification {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 1rem 1.5rem;
    border-radius: 12px;
    background: var(--color-card);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: var(--color-text);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    z-index: 1100;
    max-width: 300px;
}

.notification p {
    margin: 0;
    line-height: 1.4;
}

.close-button {
    background: none;
    border: none;
    color: var(--color-text);
    cursor: pointer;
    padding: 0;
    font-size: 1.2rem;
    transition: transform 0.3s ease;
}

.close-button:hover {
    transform: rotate(90deg);
}

.notification.info {
    border-left: 4px solid var(--color-primary);
}

.notification.success {
    border-left: 4px solid var(--color-spotify);
}

.notification.warning {
    border-left: 4px solid var(--color-netflix);
}

.notification.error {
    border-left: 4px solid var(--color-youtube);
}

.notification-enter-active,
.notification-leave-active {
    transition: all 0.5s ease;
}

.notification-enter-from,
.notification-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
</style>
